export const provinces = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT"
];

export const calendarColors = [
  "event-rose",
  "event-green",
  "event-red",
  "event-azure",
  "event-orange"
];

export const vfrCharts = [
  "Toronto VTA Back",
  "Toronto VTA Front",
  "Vancouver VTA Back",
  "Vancouver VTA Front",
  "Winnipeg VTA Back",
  "Winnipeg VTA Front",
  "Montreal VTA Front",
  "Calgary VTA Back",
  "Calgary VTA Front",
  "Ottawa VTA Front",
  "Edmonton VTA Back",
  "Edmonton VTA Front",
  "Toronto VNC North",
  "Toronto VNC South",
  "Sault Ste Marie VNC East",
  "Sault Ste Marie VNC West",
  "Montreal VNC North",
  "Montreal VNC South",
  "Moncton VNC North",
  "Moncton VNC South",
  "Vancouver VNC North",
  "Vancouver VNC South",
  "Calgary VNC North",
  "Calgary VNC South",
  "Regina VNC North",
  "Regina VNC South",
  "Winnipeg VNC North",
  "Winnipeg VNC South",
  "Thunder Bay VNC North",
  "Thunder Bay VNC South",
  "Timmins VNC North",
  "Timmins VNC South",
  "Chicoutimi VNC North",
  "Chicoutimi VNC South",
  "Anticosti VNC North",
  "Anticosti VNC South",
  "Gander VNC North",
  "Gander VNC South",
  "Kitimat VNC North",
  "Kitimat VNC South",
  "Prince George VNC North",
  "Prince George VNC South",
  "Edmonton VNC North",
  "Edmonton VNC South",
  "Flin Flon VNC North",
  "Flin Flon VNC South",
  "Big Trout Lake VNC North",
  "Big Trout Lake VNC South",
  "James Bay VNC North",
  "James Bay VNC South",
  "Wabush VNC North",
  "Wabush VNC South",
  "Goose Bay VNC North",
  "Goose Bay VNC South",
  "Atlin VNC North",
  "Atlin VNC South",
  "Fort Nelson VNC North",
  "Fort Nelson VNC South",
  "Lake Athabasca VNC North",
  "Lake Athabasca VNC South",
  "Wollaston Lake VNC North",
  "Wollaston Lake VNC South",
  "Hudson Bay VNC North",
  "Hudson Bay VNC South",
  "Inukjuak VNC North",
  "Inukjuak VNC South",
  "Ungava VNC North",
  "Ungava VNC South",
  "Whitehorse VNC North",
  "Whitehorse VNC South",
  "Fort Simpson VNC North",
  "Fort Simpson VNC South",
  "Yellowknife VNC North",
  "Yellowknife VNC South",
  "Rankin Inlet VNC North",
  "Rankin Inlet VNC South",
  "Coats Island VNC North",
  "Coats Island VNC South",
  "Frobisher Bay VNC North",
  "Frobisher Bay VNC South",
  "Klondike VNC North",
  "Klondike VNC South",
  "Great Bear Lake VNC North",
  "Great Bear Lake VNC South",
  "Bathurst Inlet VNC North",
  "Bathurst Inlet VNC South",
  "Baker Lake VNC North",
  "Baker Lake VNC South",
  "Foxe Basin VNC North",
  "Foxe Basin VNC South",
  "Cumberland Peninsula VNC North",
  "Cumberland Peninsula VNC South",
  "Mackenzie Delta VNC North",
  "Mackenzie Delta VNC South",
  "Amundsen Gulf VNC North",
  "Amundsen Gulf VNC South",
  "Cambridge Bay VNC North",
  "Cambridge Bay VNC South",
  "Boothia VNC North",
  "Boothia VNC South",
  "Baffin Bay VNC North",
  "Baffin Bay VNC South",
  "Banks Island VNC North",
  "Banks Island VNC South",
  "Resolute VNC North",
  "Resolute VNC South",
  "Devon Island VNC North",
  "Devon Island VNC South",
  "Hazen Strait VNC North",
  "Hazen Strait VNC South",
  "Ellesmere VNC North",
  "Ellesmere VNC South",
  "Alert VNC North",
  "Alert VNC South",
  "Alaska Highway VNC North",
  "Alaska Highway VNC South"
];

export const vfrChartFiles = [
  "1900_Toronto_VTA_Back",
  "1900_Toronto_VTA_Front",
  "1901_Vancouver_VTA_Back",
  "1901_Vancouver_VTA_Front",
  "1902_Winnipeg_VTA_Back",
  "1902_Winnipeg_VTA_Front",
  "1903_Montreal_VTA_Front",
  "1904_Calgary_VTA_Back",
  "1904_Calgary_VTA_Front",
  "1905_Ottawa_VTA_Front",
  "1906_Edmonton_VTA_Back",
  "1906_Edmonton_VTA_Front",
  "5000_Toronto_VNC_North",
  "5000_Toronto_VNC_South",
  "5001_Sault_Ste_Marie_VNC_East",
  "5001_Sault_Ste_Marie_VNC_West",
  "5002_Montreal_VNC_North",
  "5002_Montreal_VNC_South",
  "5003_Moncton_VNC_North",
  "5003_Moncton_VNC_South",
  "5004_Vancouver_VNC_North",
  "5004_Vancouver_VNC_South",
  "5005_Calgary_VNC_North",
  "5005_Calgary_VNC_South",
  "5006_Regina_VNC_North",
  "5006_Regina_VNC_South",
  "5007_Winnipeg_VNC_North",
  "5007_Winnipeg_VNC_South",
  "5008_Thunder_Bay_VNC_North",
  "5008_Thunder_Bay_VNC_South",
  "5009_Timmins_VNC_North",
  "5009_Timmins_VNC_South",
  "5010_Chicoutimi_VNC_North",
  "5010_Chicoutimi_VNC_South",
  "5011_Anticosti_VNC_North",
  "5011_Anticosti_VNC_South",
  "5012_Gander_VNC_North",
  "5012_Gander_VNC_South",
  "5013_Kitimat_VNC_North",
  "5013_Kitimat_VNC_South",
  "5014_Prince_George_VNC_North",
  "5014_Prince_George_VNC_South",
  "5015_Edmonton_VNC_North",
  "5015_Edmonton_VNC_South",
  "5016_Flin_Flon_VNC_North",
  "5016_Flin_Flon_VNC_South",
  "5017_Big_Trout_Lake_VNC_North",
  "5017_Big_Trout_Lake_VNC_South",
  "5018_James_Bay_VNC_North",
  "5018_James_Bay_VNC_South",
  "5019_Wabush_VNC_North",
  "5019_Wabush_VNC_South",
  "5020_Goose_Bay_VNC_North",
  "5020_Goose_Bay_VNC_South",
  "5021_Atlin_VNC_North",
  "5021_Atlin_VNC_South",
  "5022_Fort_Nelson_VNC_North",
  "5022_Fort_Nelson_VNC_South",
  "5023_Lake_Athabasca_VNC_North",
  "5023_Lake_Athabasca_VNC_South",
  "5024_Wollaston_Lake_VNC_North",
  "5024_Wollaston_Lake_VNC_South",
  "5025_Hudson_Bay_VNC_North",
  "5025_Hudson_Bay_VNC_South",
  "5026_Inukjuak_VNC_North",
  "5026_Inukjuak_VNC_South",
  "5027_Ungava_VNC_North",
  "5027_Ungava_VNC_South",
  "5028_Whitehorse_VNC_North",
  "5028_Whitehorse_VNC_South",
  "5029_Fort_Simpson_VNC_North",
  "5029_Fort_Simpson_VNC_South",
  "5030_Yellowknife_VNC_North",
  "5030_Yellowknife_VNC_South",
  "5031_RankinInlet_VNC_North",
  "5031_RankinInlet_VNC_South",
  "5032_Coats_Island_VNC_North",
  "5032_Coats_Island_VNC_South",
  "5033_Frobisher_Bay_VNC_North",
  "5033_Frobisher_Bay_VNC_South",
  "5034_Klondike_VNC_North",
  "5034_Klondike_VNC_South",
  "5035_Great_Bear_Lake_VNC_North",
  "5035_Great_Bear_Lake_VNC_South",
  "5036_Bathurst_Inlet_VNC_North",
  "5036_Bathurst_Inlet_VNC_South",
  "5037_Baker_Lake_VNC_North",
  "5037_Baker_Lake_VNC_South",
  "5038_Foxe_Basin_VNC_North",
  "5038_Foxe_Basin_VNC_South",
  "5039_Cumberland_Peninsula_VNC_North",
  "5039_Cumberland_Peninsula_VNC_South",
  "5040_Mackenzie_Delta_VNC_North",
  "5040_Mackenzie_Delta_VNC_South",
  "5041_AmundsenGulf_VNC_North",
  "5041_AmundsenGulf_VNC_South",
  "5042_CambridgeBay_VNC_North",
  "5042_CambridgeBay_VNC_South",
  "5043_Boothia_VNC_North",
  "5043_Boothia_VNC_South",
  "5044_BaffinBay_VNC_North",
  "5044_BaffinBay_VNC_South",
  "5045_Banks_Island_VNC_North",
  "5045_Banks_Island_VNC_South",
  "5046_Resolute_VNC_North",
  "5046_Resolute_VNC_South",
  "5047_Devon_Island_VNC_North",
  "5047_Devon_Island_VNC_South",
  "5048_Hazen_Strait_VNC_North",
  "5048_Hazen_Strait_VNC_South",
  "5049_Ellesmere_VNC_North",
  "5049_Ellesmere_VNC_South",
  "5050_Alert_VNC_North",
  "5050_Alert_VNC_South",
  "5099_Alaska_Highway_VNC_North",
  "5099_Alaska_Highway_VNC_South"
];

export const datetimeOptions = {
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
};

export const dateOptions = {
  year: "numeric",
  month: "long",
  day: "numeric"
};

export const shortMonthOptions = {
  year: "2-digit",
  month: "2-digit"
};

export const mapboxAccessToken =
  "pk.eyJ1IjoiYmVueWluZyIsImEiOiJjanY0b2xwYWsydDFyNDNza2syc3k3bWE1In0.DCWi1L58dBGN0Pc9BNrNyw";

export const stripeTestKey = "pk_test_gwqudTQvDjpadv2CTjh98xFq00to22Vx9h";
export const stripeProdKey = "pk_live_glMaky3osB5SUahg81jJILOA00gHuygnBL";

export const USER_TYPE = {
  ADMIN: "admin",
  SUPER: "superuser",
  FREE: "free",
  ENTERPRISE: "enterprise",
  PRO: "pro",
  PILOT: "pilot",
  MAAC: "maac",
  AIRPORT: "airport"
};

export const PILOT_NETWORK = {
  REVIEWER: "reviewer"
};

export const CHART_TYPE = {
  MISSION: "mission",
  DRONE: "drone",
  PILOT: "pilot"
};

export const threshold_drone_hours = 30;
export const threshold_pilot_days = 30;

export const EVENT_STATUS = {
  0: "Incomplete",
  1: "Pass",
  2: "Fail",
  4: "Cancelled"
};

export const DEFAULT_TIMEZONE = "America/Toronto";

export const REVIEWER_PRICE_MIN = 250;
export const REVIEWER_PRICE_MAX = 1500;

export const SURVEY_TYPE = {
  UNSELECTED: null,
  REGULAR: "",
  REVIEWER: "reviewer"
};

export const CHECKLIST_TYPE = {
  REVIEWER: "reviewer"
}

export const LANGUAGE = {
  EN: "en",
  FR: "fr"
}

export const AIR_STATUS = {
  DND: {
    oid: 1,
    title: "Your flight is within 3NM of a military aerodrome.",
    desc: "Please obtain SFOC-RPAS from Transport Canada. (CAR 903.01)"
  },
  MIL: {
    oid: 2,
    title: "Your flight is within 3NM of a military aerodrome.",
    desc: "Please obtain SFOC-RPAS from Transport Canada. (CAR 903.01)"
  },
  RESTRICTED: {
    oid: 3,
    title: "Your flight is in restricted airspace.",
    desc: "Please obtain approval from controlling agency found in the DAH."
  },
  CONTROLLED: {
    oid: 4,
    title: "Your flight is in controlled airspace.",
    desc: "Please obtain RPAS Flight Authorization using the NavDrone app or by contacting NavCanada. (CAR 901.71)"
  },
  CERT: {
    oid: 5,
    title: "Your flight is within 3NM of a certified aerodrome or 1NM of a certified heliport.",
    desc: "Please comply with Transport Canada established procedure as found in TC AIM RPA 3.4.5. (CAR 901.73)"
  },
  ADVISORY: {
    oid: 6,
    title: "Your flight is in an advisory airspace.",
    desc: "Please check whether the area is active via NOTAMs or by contacting the controlling agency found in the DAH."
  },
  UNCONTROLLED: {
    oid: 7,
    title: "",
    desc: ""
  },
}
